(function () {
  function parseList(raw) {
    if (!raw) return [];
    var s = String(raw).trim();
    if (s.startsWith('[')) {
      try {
        var a = JSON.parse(s);
        if (Array.isArray(a)) return a.map(String).map(function (v) { return v.trim(); }).filter(Boolean);
      } catch (e) { /* fall through */ }
    }
    return s.split(/[,;\n]/).map(function (v) { return v.trim(); }).filter(Boolean);
  }

  // TILPASSET: søgbar combobox der pakker et native <select> ind — 2026-07-16
  function enhanceSelect(selectEl, i18n) {
    if (selectEl.__pctyCombo) return selectEl.__pctyCombo;
    var searchPh = (i18n && i18n.searchPlaceholder) || 'Søg...';
    var noRes = (i18n && i18n.noResults) || 'Ingen resultater';

    var wrap = document.createElement('div');
    wrap.className = 'rf-combo';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rf-combo__button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var caret = document.createElement('span');
    caret.className = 'rf-combo__caret';
    caret.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.className = 'rf-combo__label';
    btn.appendChild(label);
    btn.appendChild(caret);

    var panel = document.createElement('div');
    panel.className = 'rf-combo__panel';
    panel.hidden = true;
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'rf-combo__search';
    input.placeholder = searchPh;
    input.setAttribute('aria-label', searchPh);
    input.autocomplete = 'off';
    var list = document.createElement('ul');
    list.className = 'rf-combo__list';
    list.setAttribute('role', 'listbox');
    var empty = document.createElement('div');
    empty.className = 'rf-combo__empty';
    empty.textContent = noRes;
    empty.hidden = true;

    panel.appendChild(input);
    panel.appendChild(list);
    panel.appendChild(empty);
    wrap.appendChild(btn);
    wrap.appendChild(panel);

    // TILPASSET: Hvis selectEl er inde i et <label>, vil klik på knappen boble op
    // og aktivere den native select. Flyt combobox UD af label og pak select ind
    // i wrap i stedet. — 2026-07-16
    var labelEl = selectEl.closest('label');
    if (labelEl && labelEl.parentNode) {
      labelEl.parentNode.insertBefore(wrap, labelEl);
      wrap.appendChild(selectEl);
      // Behold visually-hidden span som aria-label kilde ved at flytte den ind i wrap.
      var srSpan = labelEl.querySelector('.visually-hidden');
      if (srSpan) {
        wrap.insertBefore(srSpan, wrap.firstChild);
        // Sæt aria-label på knappen fra visually-hidden span — 2026-07-18
        var srText = srSpan.textContent.trim();
        if (srText) btn.setAttribute('aria-label', srText);
      }
      // Fjern nu tom label.
      if (!labelEl.textContent.trim()) labelEl.remove();
    } else {
      selectEl.parentNode.insertBefore(wrap, selectEl);
      wrap.appendChild(selectEl);
    }
    selectEl.classList.add('rf-combo__native');
    selectEl.setAttribute('tabindex', '-1');
    selectEl.setAttribute('aria-hidden', 'true');

    function syncLabel() {
      var opt = selectEl.options[selectEl.selectedIndex];
      label.textContent = opt ? opt.textContent : '';
      wrap.classList.toggle('rf-combo--empty', !selectEl.value);
    }

    function rebuildList(filter) {
      list.innerHTML = '';
      var q = (filter || '').trim().toLowerCase();
      var shown = 0;
      for (var i = 0; i < selectEl.options.length; i++) {
        var opt = selectEl.options[i];
        if (opt.value === '') continue; // hide placeholder
        var txt = opt.textContent;
        if (q && txt.toLowerCase().indexOf(q) === -1) continue;
        var li = document.createElement('li');
        li.className = 'rf-combo__item' + (opt.value === selectEl.value ? ' is-selected' : '');
        li.setAttribute('role', 'option');
        li.setAttribute('data-value', opt.value);
        li.textContent = txt;
        li.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          var v = this.getAttribute('data-value');
          selectEl.value = v;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          close();
        });
        list.appendChild(li);
        shown++;
      }
      empty.hidden = shown !== 0;
    }

    function open() {
      if (selectEl.disabled) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      input.value = '';
      rebuildList('');
      setTimeout(function () { input.focus(); }, 0);
      document.addEventListener('mousedown', onDocDown, true);
      document.addEventListener('keydown', onKey, true);
    }
    function close() {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('mousedown', onDocDown, true);
      document.removeEventListener('keydown', onKey, true);
    }
    function onDocDown(ev) { if (!wrap.contains(ev.target)) close(); }
    function onKey(ev) { if (ev.key === 'Escape') { close(); btn.focus(); } }

    btn.addEventListener('click', function () {
      if (panel.hidden) open(); else close();
    });
    input.addEventListener('input', function () { rebuildList(input.value); });

    // Public API used after options change externally.
    var api = {
      refresh: function () { syncLabel(); if (!panel.hidden) rebuildList(input.value); },
      close: close,
    };
    selectEl.__pctyCombo = api;

    // Update label when select changes programmatically or via user pick.
    selectEl.addEventListener('change', syncLabel);
    syncLabel();
    return api;
  }

  function init(root) {
    var dataEl = root.querySelector('[data-rifle-data]');
    var i18n = {};
    try { i18n = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}
    var raw = {};
    try { raw = JSON.parse(dataEl.textContent); } catch (e) { raw = { products: [] }; }
    var products = (raw.products || []).slice();
    var debug = raw.debug || {};
    var sectionId = dataEl.getAttribute('data-rifle-section-id');
    var collectionHandle = dataEl.getAttribute('data-rifle-collection');
    var totalPages = parseInt(dataEl.getAttribute('data-rifle-total-pages') || '1', 10);
    try {
      console.log('[Rifelfinder] debug', debug, 'produkter med mærke på side 1:', products.length);
    } catch (e) {}

    var brandSel = root.querySelector('[data-rifle-brand]');
    var modelSel = root.querySelector('[data-rifle-model]');
    var submitBtn = root.querySelector('[data-rifle-submit]');
    var notice = root.querySelector('[data-rifle-notice]');
    var resultsWrap = root.querySelector('[data-rifle-results]');
    var resultsHeading = root.querySelector('[data-rifle-results-heading]');
    var grid = root.querySelector('[data-rifle-grid]');
    var empty = root.querySelector('[data-rifle-empty]');

    var brandMap = {};

    function rebuildBrandList() {
      brandMap = {};
      products.forEach(function (p) {
        parseList(p.brand).forEach(function (b) {
          if (!brandMap[b]) brandMap[b] = {};
          parseList(p.model).forEach(function (m) { brandMap[b][m] = true; });
        });
      });

      var brands = Object.keys(brandMap).sort(function (a, b) { return a.localeCompare(b); });

      if (brands.length === 0) {
        var msg = i18n.noConfig || '';
        if (debug && typeof debug.total_in_collection === 'number') {
          msg += ' (Kollektion: "' + (debug.collection || '?') + '", produkter i alt: ' + debug.total_in_collection + ')';
        }
        notice.textContent = msg;
        notice.hidden = false;
        brandSel.disabled = true;
        return;
      }

      notice.hidden = true;
      brandSel.disabled = false;
      // Preserve current value, clear and rebuild options.
      var current = brandSel.value;
      while (brandSel.options.length > 1) brandSel.remove(1);
      brands.forEach(function (b) {
        var o = document.createElement('option');
        o.value = b; o.textContent = b;
        brandSel.appendChild(o);
      });
      if (current) brandSel.value = current;
      if (brandSel.__pctyCombo) brandSel.__pctyCombo.refresh();
    }

    // TILPASSET: pak selects ind som søgbare comboboxes — 2026-07-16
    enhanceSelect(brandSel, i18n);
    enhanceSelect(modelSel, i18n);

    rebuildBrandList();

    function buildSectionPageUrl(page) {
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', page);
      return url.toString();
    }

    // Fetch remaining pages of the same rendered section (Shopify caps coll.products at 50/page).
    if (sectionId && collectionHandle && totalPages > 1) {
      var fetches = [];
      for (var p = 2; p <= totalPages; p++) {
        (function (page) {
          fetches.push(
            fetch(buildSectionPageUrl(page), { credentials: 'same-origin' })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var m = html.match(/<script[^>]*data-rifle-data[^>]*>([\s\S]*?)<\/script>/);
                if (!m) return;
                try {
                  var json = JSON.parse(m[1]);
                  if (json && Array.isArray(json.products)) {
                    products = products.concat(json.products);
                  }
                } catch (e) { /* ignore page */ }
              })
              .catch(function () { /* ignore page */ })
          );
        })(p);
      }
      Promise.all(fetches).then(function () {
        try { console.log('[Rifelfinder] hentede alle sider, produkter med mærke i alt:', products.length); } catch (e) {}
        rebuildBrandList();
      });
    }


    function refreshModels() {
      // clear
      while (modelSel.firstChild) modelSel.removeChild(modelSel.firstChild);
      var brand = brandSel.value;
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = brand ? (i18n.allModels || '') : (i18n.selectModelFirst || '');
      modelSel.appendChild(ph);
      if (!brand) { modelSel.disabled = true; return; }
      modelSel.disabled = false;
      Object.keys(brandMap[brand]).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (m) {
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        modelSel.appendChild(o);
      });
      if (modelSel.__pctyCombo) modelSel.__pctyCombo.refresh();
    }

    function updateSubmit() {
      submitBtn.disabled = !brandSel.value;
    }

    function productMatches(p, brand, model) {
      var bs = parseList(p.brand);
      var ms = parseList(p.model);
      if (bs.indexOf(brand) === -1) return false;
      if (model && ms.indexOf(model) === -1) return false;
      return true;
    }

    function render() {
      var brand = brandSel.value;
      var model = modelSel.value;
      if (!brand) return;

      var matches = products.filter(function (p) { return productMatches(p, brand, model); });

      var template = matches.length === 1 ? (i18n.resultsOne || '') : (i18n.resultsMany || '');
      resultsHeading.textContent = template
        .replace('{count}', matches.length)
        .replace('{brand}', brand)
        .replace('{model}', model || '')
        .replace(/\s+/g, ' ')
        .trim();

      while (grid.firstChild) grid.removeChild(grid.firstChild);

      if (matches.length === 0) {
        empty.textContent = i18n.emptyState || '';
        empty.hidden = false;
      } else {
        empty.hidden = true;
        matches.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'rifle-finder__item';
          var sub = [p.finish, p.material].filter(Boolean).join(' ');
          var priceAttr = (p.priceCents != null) ? ' data-pcty-price-cents="' + p.priceCents + '"' : '';
          li.innerHTML =
            '<a href="' + p.url + '" class="rifle-finder__link">' +
              '<div class="rifle-finder__media">' +
                (p.image ? '<img src="' + p.image + '" alt="' + (p.imageAlt || p.title).replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="rifle-finder__body">' +
                '<h4 class="rifle-finder__title">' + p.title + '</h4>' +
                (sub ? '<p class="rifle-finder__meta">' + sub + '</p>' : '') +
                (p.vendor ? '<p class="rifle-finder__meta">' + p.vendor + '</p>' : '') +
                '<p class="rifle-finder__price"' + priceAttr + '>' + p.price + '</p>' +
              '</div>' +
            '</a>';
          grid.appendChild(li);
        });
        if (window.PctyCurrency && typeof window.PctyCurrency.convertAll === 'function') {
          window.PctyCurrency.convertAll(grid);
        }
      }
      resultsWrap.hidden = false;
    }

    brandSel.addEventListener('change', function () {
      refreshModels();
      updateSubmit();
    });
    modelSel.addEventListener('change', updateSubmit);
    submitBtn.addEventListener('click', render);

    refreshModels();
    updateSubmit();
  }

  function boot() {
    document.querySelectorAll('[data-rifle-finder]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
